import { C, SERIF, SANS, PAGE_W, PAGE_H } from "./theme";
import { ReportHeader, ReportFooter, Eyebrow } from "./ReportChrome";
import { gbp, pct, FULL_MONTHS } from "./reportUtils";
import MonthlyChart from "./MonthlyChart";

export default function MonthlyPage({ pageRef, host, address, cityName, rows, T, peak, peakMonths, quiet, warmUp }) {
  return (
    <div ref={pageRef} style={{ width: PAGE_W, height: PAGE_H, background: "#fff", color: C.evergreen, position: "relative", overflow: "hidden", display: "flex", flexDirection: "column" }}>
      <ReportHeader host={host} address={address} cityName={cityName} />
      <div style={{ padding: "30px 64px 0", flex: 1, display: "flex", flexDirection: "column", minHeight: 0 }}>
        <Eyebrow>Month by month</Eyebrow>
        <h2 style={{ fontFamily: SERIF, fontWeight: 400, fontSize: 30, lineHeight: 1.1, letterSpacing: "-0.01em", margin: "10px 0 12px" }}>
          How your income moves through the year
        </h2>
        <p style={{ fontFamily: SANS, fontSize: 12.5, lineHeight: 1.6, color: C.muted, maxWidth: 560, margin: 0 }}>
          Strongest in {peakMonths.map((m) => FULL_MONTHS[m]).join(" and ")} at {gbp(peak.net)}, quietest in {FULL_MONTHS[quiet.month]} at {gbp(quiet.net)}. Our pricing rises into busy periods and protects occupancy in quieter months.
        </p>

        <div style={{ marginTop: 22 }}>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 18, fontFamily: SANS, fontSize: 9.5, color: C.muted, marginBottom: 6 }}>
            <span><i style={{ width: 9, height: 9, borderRadius: 2, display: "inline-block", background: C.evergreen, marginRight: 6 }} />Net to you</span>
            <span><i style={{ width: 9, height: 9, borderRadius: 2, display: "inline-block", background: C.peach, marginRight: 6 }} />Fees, VAT and platform</span>
          </div>
          <MonthlyChart rows={rows} height={180} />
        </div>

        <div style={{ marginTop: 22 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontFamily: SANS, fontSize: 10 }}>
            <thead>
              <tr>
                {["Month", "Occupancy", "Nights", "Avg rate", "Gross", "All fees", "Net to you"].map((h, i) => (
                  <th key={h} style={{ fontSize: 8.5, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", color: C.faint, textAlign: i === 0 ? "left" : "right", padding: "0 6px 8px", borderBottom: `1px solid ${C.evergreen}` }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={i} style={r.net === peak.net ? { background: C.tea } : undefined}>
                  <td style={{ padding: "6px 6px", borderBottom: `1px solid ${C.line}` }}>{FULL_MONTHS[r.month]}</td>
                  <td style={{ padding: "6px 6px", textAlign: "right", borderBottom: `1px solid ${C.line}` }}>{pct(r.occ)}</td>
                  <td style={{ padding: "6px 6px", textAlign: "right", borderBottom: `1px solid ${C.line}` }}>{r.nights}</td>
                  <td style={{ padding: "6px 6px", textAlign: "right", borderBottom: `1px solid ${C.line}` }}>{gbp(r.adr)}</td>
                  <td style={{ padding: "6px 6px", textAlign: "right", borderBottom: `1px solid ${C.line}` }}>{gbp(r.gross)}</td>
                  <td style={{ padding: "6px 6px", textAlign: "right", color: C.muted, borderBottom: `1px solid ${C.line}` }}>{gbp(r.mgmt + r.vat + r.plat)}</td>
                  <td style={{ padding: "6px 6px", textAlign: "right", fontWeight: 600, borderBottom: `1px solid ${C.line}` }}>{gbp(r.net)}</td>
                </tr>
              ))}
              <tr>
                <td style={{ padding: "10px 6px 0", fontWeight: 700, borderTop: `1px solid ${C.evergreen}` }}>Year</td>
                <td style={{ padding: "10px 6px 0", textAlign: "right", fontWeight: 700, borderTop: `1px solid ${C.evergreen}` }}>{pct(T.occ)}</td>
                <td style={{ padding: "10px 6px 0", textAlign: "right", fontWeight: 700, borderTop: `1px solid ${C.evergreen}` }}>{T.nights}</td>
                <td style={{ padding: "10px 6px 0", textAlign: "right", fontWeight: 700, borderTop: `1px solid ${C.evergreen}` }}>{gbp(T.adr)}</td>
                <td style={{ padding: "10px 6px 0", textAlign: "right", fontWeight: 700, borderTop: `1px solid ${C.evergreen}` }}>{gbp(T.gross)}</td>
                <td style={{ padding: "10px 6px 0", textAlign: "right", fontWeight: 700, borderTop: `1px solid ${C.evergreen}` }}>{gbp(T.mgmt + T.vat + T.plat)}</td>
                <td style={{ padding: "10px 6px 0", textAlign: "right", fontWeight: 700, borderTop: `1px solid ${C.evergreen}` }}>{gbp(T.net)}</td>
              </tr>
            </tbody>
          </table>
          <p style={{ fontFamily: SANS, fontSize: 10, lineHeight: 1.55, color: C.muted, marginTop: 12 }}>
            {warmUp ? "Months one to three are reduced to reflect the warm-up period while the listing builds reviews." : "New listings usually take two to three months to build reviews, so early months may come in lower."}
          </p>
        </div>
      </div>
      <ReportFooter page={3} />
    </div>
  );
}